package org.hs_soft.runmynesto.domain.usecase.product.tab_selection

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.delete_product_set.ProductSetModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.selection.ProductSetData
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_selection.UpdateProductSetListRepository

class UpdateProductSetsListUseCase(
    private val repository: UpdateProductSetListRepository
) {
    suspend operator fun invoke(
        id:String,
        sets:List<ProductSetData>,
    ):ProductSetModel {

        return repository.updateProductSetList(
            id = id,
            sets=sets
        )
    }
}